export const Bio = {
  name: "Hodaifa Echffani",
  roles: ["Full Stack Developer", "Android Developer", "DevOps Engineer", "Cloud Specialist", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/hodaifa-ech",
  resume: "https://drive.google.com/file/d/1mweIeQlNatWeSuggbS5eYwr81qNjde23/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hodaifa-echffani-297b7b284",
  twitter: "https://twitter.com/hodaifaechffani",
  insta: "https://www.instagram.com/hodaifa_echffani/",
  facebook: "https://www.facebook.com/houdayf.echeffani/",
}

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Angular",
        image: "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Spring Boot",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Laravel",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg",
      },
      {
        name: "Symfony",
        image: "https://symfony.com/logos/symfony_black_03.svg",
      },
      {
        name: "Java EE (JEE)",
        image: "https://www.vectorlogo.zone/logos/oracle/oracle-icon.svg",
      },
      {
        name: "Django",
        image: "https://cdn.worldvectorlogo.com/logos/django.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "AI & Machine Learning",
    skills: [
      {
        name: "Machine Learning",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Hey_Machine_Learning_Logo.png",
      },
      {
        name: "Deep Learning",
        image: "https://www.svgrepo.com/show/306500/openai.svg",
      },
      {
        name: "RAG",
        image: "https://cdn-icons-png.flaticon.com/512/8637/8637099.png",
      },
      {
        name: "Fine-tuning",
        image: "https://www.svgrepo.com/show/452210/git.svg",
      },
      {
        name: "n8n",
        image: "https://n8n.io/favicon.ico",
      },
      {
        name: "LLM",
        image: "https://cdn-icons-png.flaticon.com/512/8637/8637108.png",
      },
    ],
  },
  {
    title: "DevOps & Cloud",
    skills: [
      {
        name: "AWS",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "Docker",
        image: "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png",
      },
      {
        name: "Kubernetes (K8s)",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg",
      },
      {
        name: "K3s",
        image: "https://k3s.io/img/k3s-logo-light.svg",
      },
      {
        name: "Jenkins",
        image: "https://www.vectorlogo.zone/logos/jenkins/jenkins-icon.svg",
      },
      {
        name: "Terraform",
        image: "https://www.vectorlogo.zone/logos/terraformio/terraformio-icon.svg",
      },
      {
        name: "Ansible",
        image: "https://www.vectorlogo.zone/logos/ansible/ansible-icon.svg",
      },
      {
        name: "Kafka",
        image: "https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-icon.svg",
      },
      {
        name: "SonarQube",
        image: "https://cdn.worldvectorlogo.com/logos/sonarqube.svg",
      },
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub Actions",
        image: "https://github.githubassets.com/images/modules/site/features/actions-icon-actions.svg",
      },
      {
        name: "EKS",
        image: "https://www.svgrepo.com/show/376354/amazon-eks.svg",
      },
      {
        name: "ECR",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrDHURZovzN7Xoo0_PB4etEx8tV3ZoPLkp_g&s",
      },
      {
        name: "Ubuntu",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9e/UbuntuCoF.svg",
      },
      {
        name: "Linux",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg",
      },
      {
        name: "Kubeflow",
        image: "https://v1-9-branch.kubeflow.org/docs/images/logos/kubeflow.png",
      },
    ],
  },
  {
    title: "Android & Mobile",
    skills: [
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image: "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Flutter",
        image: "https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg",
      },
    ],
  },
  {
    title: "Game Development",
    skills: [
      {
        name: "C#",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
      },
      {
        name: "Unity",
        image: "https://upload.wikimedia.org/wikipedia/commons/1/19/Unity_Technologies_logo.svg",
      },
    ],
  },
  {
    title: "Project Management & Collaboration",
    skills: [
      {
        name: "Jira",
        image: "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
      {
        name: "Scrum",
        image: "https://cdn.worldvectorlogo.com/logos/scrum-1.svg",
      },
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "IntelliJ IDEA",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9c/IntelliJ_IDEA_Icon.svg",
      },
      {
        name: "Postman",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Figma",
        image: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
    ],
  },
]

export const experiences = [
  {
    id: 0,
    image: "onetechma_logo.jpeg",
    role: "Fullstack Developer",
    company: "One Technologies",
    date: "June 2024 - Sept 2024",
    desc: "Working on web applications for managing commercial sales, stock purchases, clients, and suppliers with dynamic parameters.",
    skills: ["Laravel", "Tailwind CSS", "CSS", "JavaScript", "Testing", "OCR"],
  },
  {
    id: 1,
    image: "images.jpeg", // You may need to add the actual logo file
    role: "Backend Developer",
    company: "Cloud marketing hub",
    date: "June 2025 - August 2025",
    location: "Tangier, Morocco",
    desc: "Improved database performance and reduced downtime. Implemented Kafka for asynchronous and ordered data synchronization as well as fast insertion. Deployed applications on Linux with k3s, using Kubernetes for orchestration, CI/CD for automation, DevOps best practices, and enhanced server security.",
    skills: [
      "Spring Boot",
      "PostgreSQL",
      "Apache Kafka",
      "Kubernetes",
      "Docker",
      "Git",
      "GitHub",
      "Django",
      "Java",
      "Python",
      "AWS",
      "K3S",
      "Linux",
      "SonarQube",
      "Jenkins",
    ],
  },
]

export const certificates = [
  {
    id: 1,
    title: "Developing Front-End Apps with React",
    issuer: "Coursera",
    date: "April 2024",
    description: "Completed a comprehensive course on React.js fundamentals.",
    img: "1715083442192.jpeg",
  },
  {
    id: 2,
    title: "Oracle Cloud Infrastructure 2023 AI Certified ",
    issuer: "Oracle",
    date: "June 2024",
    description: "Oracle AI services ,Oracle Generative AI",
    img: "Screenshot from 2024-10-31 23-30-53.png",
  },
  {
    id: 3,
    title: "Postman API Fundamentals Student Expert",
    issuer: "freeCodeCamp",
    date: "December 2024",
    description: "How to use Postman to work with APIs",
    img: "Screenshot from 2024-10-31 23-33-39.png",
  },
  {
    id: 4,
    title: "AWS Certified Cloud Practitioner",
    issuer: "Amazon Web Services (AWS)",
    date: "2024",
    description: "Foundational understanding of AWS Cloud concepts, services, security, architecture, pricing, and support",
    img: "aws-certified-cloud-practitioner.png",
  },
];

export const education = [
  {
    id: 0,
    img: "tanger.png",
    school: "Faculty of Science and Technology in Tangier",
    date: "Oct 2023 ",
    desc: "I'm currently a software engineering student",
    degree: "Software Engineering and Intelligent Systems",
  },
  {
    id: 1,
    img: "fes.png",
    school: "Faculty of Science and Technology in Fes",
    date: "Oct 2021 -  June 2023",
    desc: "I completed my two-year preparatory program in university studies focusing on mathematics, physics, and basic computer science",
    degree: "DEUST",
  },
  {
    id: 2,
    img: "images.png",
    school: "EL amir moulay el hassan high school",
    date: "Oct 2019  - June 2021",
    desc: "I completed my baccalaureate education in Science with Physics.",
    degree: "Baccalaureate, Science with Physics",
  },
]

export const projects = [
  {
    id: 9,
    title: "Management of a supermarket",
    date: "feb 2024 - Jul 2024",
    description:
      "Comprehensive system for managing supermarket operations including inventory, sales, and customer data.",
    image: "/Screenshot from 2024-10-16 13-08-43.png",
    tags: ["HTML", "CSS", "BOOTSTRAP", "JS", "MYSQL", "UML"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/Uml",
  },
  {
    id: 11,
    title: "Student Money Management App",
    date: "Jan 2024 - Apr 2024",
    description:
      "Developed a comprehensive money management application for students to track expenses, create monthly budgets by category, set financial goals with statistics, send money to friends, and earn points through gamification features.",
    image: "/tawfir.png?height=400&width=600",
    tags: ["Next.js", "Spring Boot", "Docker", "Tailwind CSS", "MySQL"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/tawfir-front",
  },
  {
    id: 12,
    title: "Financial Trading & Credit Risk Platform",
    date: "May 2023 - Dec 2023",
    description:
      "Built a financial application similar to Binance for trading prediction using deep learning and credit risk assessment with machine learning classification. Implemented with microservice architecture using DevOps methodology and tools including Jenkins, Docker, SonarQube, Git, Kubernetes, Terraform, and AWS for automation, deployment and testing.",
    image: "/trading.png?height=400&width=600",
    tags: ["Deep Learning", "Microservices", "DevOps", "Docker", "Kubernetes", "AWS", "Terraform"],
    category: "machine learning",
    github: "https://github.com/Fintech-LSI",
  },
  {
    id: 13,
    title: "Merciboi App Deployment Automation",
    date: "Feb 2023 - Apr 2023",
    description:
      "Automated the deployment process for the Merciboi application using Jenkins CI/CD pipeline integrated with GitHub. Implemented container orchestration with EKS and ECR, used Docker for containerization, and managed clusters with Ansible. Infrastructure was provisioned using Terraform for Jenkins instances and EKS.",
    image: "/devops.drawio.png?height=400&width=600",
    tags: ["Jenkins", "GitHub", "EKS", "ECR", "Docker", "Ansible", "Terraform"],
    category: "devops",
    github: "https://github.com/hodaifa-ech/cicd_Merciboi",
  },
  {
    id: 14,
    title: "Microservice Flask App Deployment",
    date: "Nov 2022 - Jan 2023",
    description:
      "Automated the deployment of a microservice application built with Flask using Jenkins for CI/CD, ECR for container registry, EKS for Kubernetes orchestration, and GitHub for version control. Used Terraform for infrastructure as code and Ansible for configuration management.",
    image: "/1.png?height=400&width=600",
    tags: ["Flask", "Jenkins", "ECR", "EKS", "GitHub", "Terraform", "Ansible"],
    category: "devops",
    github: "https://github.com/hodaifa-ech/Flask-microservice",
  },
  {
    id: 0,
    title: "Managing Commercial",
    date: "June 2024 - Sept 2024",
    description:
      "Developed a full-stack web application that allows users to managing commercial sales, stock purchases, clients, and suppliers with dynamic parameters",
    image: "Screenshot from 2024-10-17 12-56-04.png",
    tags: ["JavaScript", "Laravel", "OCR", "Tailwind CSS", "MySQL"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/Gestion-Commerciale",
  },
  {
    id: 1,
    title: "Dungeon Loop",
    date: "Mar 2024 - June 2024",
    description:
      "Developed a 2D top-down game featuring procedural map generation as well as pathfinding algorithms such as Dijkstra and A*. The game provides an immersive experience with dynamically generated maps and challenging navigation scenarios.",
    image: "44f7a9b1-41d4-4f3c-a1cd-1e812590a4f9.jpeg",
    tags: ["Unity", "C#", "Pathfinding"],
    category: "Game",
    github: "https://github.com/hodaifa-ech/Unity-Project-Procedural-Map-Generation-PathFinding",
  },
  {
    id: 2,
    title: "BOOK Network",
    date: "Oct 2024 - present",
    description:
      "E-commerce platform for books with user authentication, product catalog, shopping cart, and order management.",
    image: "Screenshot from 2024-10-17 13-00-01.png",
    tags: ["Angular", "Spring Boot", "Tailwind CSS", "Docker", "PostgreSQL"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/ecommerce-spring_boot",
  },
  {
    id: 3,
    title: "Gaming Club",
    date: "Mar 2024 - June 2024",
    description: "Developed a full-stack web application for gaming clubs to manage members, events, and tournaments.",
    image: "4eb47daa-6011-4c11-8761-54dd9eb6495c.jpeg",
    tags: ["Tailwind CSS", "CSS", "PHP", "MySQL"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/Club_Gaming_FSTT_Website",
  },
  {
    id: 10,
    title: "Task Management",
    date: "Mar 2024 - Sept 2024",
    description:
      "Dashboard for management of tasks with features for task creation, assignment, tracking, and reporting.",
    image: "Screenshot from 2024-10-17 13-06-05.png",
    tags: ["React.js", "JavaScript", "Axios", "Laravel", "MySQL", "Livewire"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/Gestion-Commerciale",
  },
  {
    id: 4,
    title: "E-commerce",
    date: "Jul 2021",
    description:
      "Full-featured e-commerce platform with product catalog, shopping cart, user authentication, and order management.",
    image: "Screenshot from 2024-10-17 13-17-09.png",
    tags: ["JavaScript", "CSS", "MySQL", "Symfony", "Bootstrap"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/ecommerce-website",
  },
  {
    id: 5,
    title: "Fitness Tracker",
    date: "Oct 2024 - present",
    description:
      "Application for tracking fitness activities, setting goals, and monitoring progress with detailed analytics.",
    image: "Pasted image.png",
    tags: ["Angular", "Spring Boot", "Tailwind CSS", "MySQL"],
    category: "web app",
    github: "https://github.com/hodaifa-ech/fitness_tracker",
  },
  {
    id: 15,
    title: "Smart E-commerce AI Pipeline",
    date: "Nov 2024 - Present",
    description:
      "Developed an intelligent and automated system for scraping product data from Shopify and WooCommerce platforms, analyzing products to identify top performers using ML algorithms. Implemented distributed web scraping with A2A agents, ML analysis with BI visualization, Kubeflow pipeline orchestration for ML workflows, and LLM integration for enriched analysis and strategic recommendations. Designed responsible AI agents architecture based on Anthropic's Model Context Protocol.",
    image: "application-access.png",
    tags: ["Kubeflow", "ML", "Web Scraping", "LLMs", "Docker", "CI/CD", "BI", "Python", "Kubernetes", "A2A Agents"],
    category: "machine learning",
    github: "https://github.com/hodaifa-ech/smart-ecommerce-ai-pipeline",
  },
]

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
]
